export default "__VITE_ASSET__250cb54f__"